import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside-decorator';
import { dropdownCloseEventName } from '../constants';
class DropdownContent extends Component {
    componentDidMount() {
        if (this.props.closeWhenOtherOpened) {
            document.addEventListener(dropdownCloseEventName, this.props.onOpenOtherDropdown, false);
        }
    }
    componentWillUnmount() {
        if (this.props.closeWhenOtherOpened) {
            document.removeEventListener(dropdownCloseEventName, this.props.onOpenOtherDropdown, false);
        }
    }
    render() {
        const { className, children, expandableFromVertical, visible, snapBottom, snapRight, closeWhenOtherOpened, onClickOutside, onOpenOtherDropdown, ...other } = this.props;
        return /*#__PURE__*/ React.createElement("div", {
            className: cx('Dropdown-content', {
                'Dropdown-content--visible': visible
            }, {
                'Dropdown-content--snapBottom': snapBottom
            }, {
                'Dropdown-content--snapRight': snapRight
            }, {
                'Dropdown-content--expandFromVertical': expandableFromVertical
            }, className),
            ...other
        }, children);
    }
}
DropdownContent.propTypes = {
    /**
	 * Children will be rendered within the `DropdownContent`.
	 */ children: PropTypes.node,
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string,
    /**
	 * DropdownContent will be closed when other Dropdown is opened. Default true.
	 */ closeWhenOtherOpened: PropTypes.bool,
    /**
	 * If true, `DropdownContent` has verticalExpandable class (Typically use for vertical menus)
	 */ expandableFromVertical: PropTypes.bool,
    /**
	 * Dropdown's callback implements hiding of DropdownContent.
	 */ onOpenOtherDropdown: PropTypes.func,
    /**
	 * If true, `DropdownContent` has snapBottom class
	 */ snapBottom: PropTypes.bool,
    /**
	 * If true, `DropdownContent` has snapRight class
	 */ snapRight: PropTypes.bool,
    /**
	 * If true, `DropdownContent` has visible class
	 */ visible: PropTypes.bool
};
export { DropdownContent };
export default onClickOutside(DropdownContent);
